import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { getDrupalLanguage } from '../../../drupal/types_and_parser/extra_types.mod'
import { getFormState } from '../../../form/api'
import { FormState } from '../../../form/types'
import { getLangFromUrl } from '../../utils/history.mod'
import { getVacancy } from './api'

export type VacancyDetailState = {
  get_vacancy: AsyncState<Vacancy>
  form: FormState & { custom_context?: { VacancyId: string; Kind: string; Language: string } }
  current_view: 'vacancy-detail' | 'apply-form'
}

export type Vacancy = {
  Id: string
  Name: string
  Description: string
  Price: number
  TotalRatings: number
  NumberOfRatings: number
  ImageURL?: any
  Kind: string
  Language: string
  Country: string
  City: string
  Department: string
  IsFulltime: boolean
  OriginalId: string
  Recruiter: Recruiter
  Categories?: any
}

export type Recruiter = {
  Email: string
  Name: string
  PhoneNumber: string
}

export const initialVacancyDetailState = (vacancyId: string): VacancyDetailState => ({
  get_vacancy: loadingAsyncState(() => getVacancy(vacancyId)),
  current_view: 'vacancy-detail',
  form: {
    ...getFormState([], `VacancyApplication2`, vacancyId),
    custom_context: { VacancyId: vacancyId, Kind: '', Language: getDrupalLanguage(getLangFromUrl()) }
  }
})
